import api from '../../../lib/api'
import history from 'history/browser';
let currentTabView = 'map';

const serialize = function(obj, prefix) {
    var str = [],
      p;
    for (p in obj) {
      if (obj.hasOwnProperty(p)) {
        var k = prefix ? prefix + "[" + p + "]" : p,
          v = obj[p];
        str.push((v !== null && typeof v === "object") ?
          serialize(v, k) :
          encodeURIComponent(k) + "=" + (v ? encodeURIComponent(v) : ''));
      }
    }
    return str.join("&");
  }
  

export const searchActivities = (values, filters, limit = false, page = null, tabView) =>
    function get(dispatch) {
        let searchTerms = values;
        searchTerms.filters = filters;

        if (limit) {
            searchTerms.limit = 1000;
            delete searchTerms.page;
        } else {
            searchTerms.page = page;
        }

        if(tabView) {
            currentTabView = tabView;
        }
        console.log('fire', tabView, currentTabView);
        searchTerms.tabView = currentTabView;

        const searchString = serialize(searchTerms);
        history.push({
            pathname: window.location.pathname,
            search: `?${searchString}`
        });
        console.log(searchString,
            window.location.pathname);
        console.log(searchTerms);
        api.searchActivities(searchTerms, (error, response) => {

            if (error) {
                return dispatch(searchActivitiesError(error));
            }
            const res = response.data.data;
            return dispatch(getActivitiesSuccess(res));
        });
    };
export const getActivitiesSuccess = data => ({
    type: 'SEARCH_ACTIVITIES_SUCCESS',
    data,
});

export const searchActivitiesError = msg => ({
    type: 'SEARCH_ACTIVITIES_SUCCESS',
    msg,
});

export const setSearchValue = (key, value, reset = false) => ({
    type: 'SET_SEARCH_VALUE',
    data: {key, value,  reset}
});
